import { shallowReactive } from 'vue'
import Modal from '@js/components/ui/modals/modal';
import ModalsContainer from '@js/components/ui/modals/modals-container';

const defineApi = () => {
    return {
        modals: shallowReactive([]),
        show(_modal, ...args) {
            switch (typeof _modal) {
                case 'string':
                    return this.toggle(_modal, true, ...args)
                case 'object': {
                    const defaultModal = {
                        modelValue: true,
                        uid: Symbol('modal'),
                        component: Modal,
                        bind: {},
                        slots: {},
                        on: {},
                        params: args[0],
                    }
                    const newModal = shallowReactive(Object.assign(defaultModal, _modal));
                    this.modals.push(newModal)
                    return newModal.uid;
                }
            }
        },
        close(...uids) {
            return this.toggle(uids, false)
        },
        closeAll() {
            return this.close(...this.modals.map(_modal => _modal.uid))
        },
        toggle(uid, ...args) {
            const modals = Array.isArray(uid) ? this.get(...uid) : this.get(uid)
            return modals.map(_modal => { _modal.modelValue = args[0] })
        },
        get(...uids) {
            return this.modals.filter(_modal => uids.includes(_modal.uid))
        },
    }

}

const installPlugin = (app, options = {}) => {
    const api = defineApi();
    Object.defineProperty(app.config.globalProperties, 'modalsApi', {
        get() {
            return api
        }
    })

    app.component('modals-container',  ModalsContainer);
    app.component('modal', Modal);
    app.provide('modalsApi', api);
}

export default {
    install: (app, options) => {
        const stackOptions = Object.assign({}, options)
        installPlugin(app, stackOptions)
    }
}